import { today } from "@/libraries/date";
import { fallback } from "@tanstack/router-zod-adapter";
import type { Dayjs } from "dayjs";
import dayjs from "dayjs";
import { z } from "zod";
import { DataIdSchema } from "./auth";

export const CalendarPageSearchSchema = z.object({
	date: fallback(z.string(), today().format("DD-MM-YYYY")),
	eid: DataIdSchema.optional(),
	rid: DataIdSchema.optional(),
});
export type CalendarPageSearchSchema = z.infer<typeof CalendarPageSearchSchema>;

export const CalendarRootPageSearchSchema = CalendarPageSearchSchema.pick({
	date: true,
});
export type CalendarRootPageSearchSchema = z.infer<
	typeof CalendarRootPageSearchSchema
>;

export const CreateOrUpdateCalendarFieldSchema = z.object({
	date: z
		.custom<Dayjs>((val) => dayjs.isDayjs(val), {
			message: "Invalid date",
		})
		.refine((val) => val != null, {
			message: "Date is required",
		}),
	end: z
		.custom<Dayjs>((val) => dayjs.isDayjs(val), {
			message: "Invalid date",
		})
		.optional(),
	title: z
		.string()
		.min(1, "Title is required")
		.max(50, "Title must be less than 50 characters"),
	description: z
		.string()
		.max(100, "Description must be less than 100 characters")
		.optional(),
	id: DataIdSchema.optional(),
});
export type CreateOrUpdateCalendarFieldSchema = z.infer<
	typeof CreateOrUpdateCalendarFieldSchema
>;
